<template lang="pug">
    #deal.right-panel.md-elevation-1.md-scrollbar.md-theme-default
        .entity-card
            .md-layout.md-gutter.entity-card-head(v-if="deal")
                .md-layout-item.md-layout.common
                    .md-layout-item.entity-head-left(v-if="deal.first_freight && deal.first_freight.traking_number")
                        .traking-number {{deal.first_freight.traking_number}}
                    
                        //.md-layout-item.entity-head-center
                        .status(v-if="blockDeal")
                            .deny(v-if="isIssusedToClient") Груз выдан клиенту!
                            .deny(v-else) Изменение заявки заблокированно
                        .status(v-if="!blockDeal && blockCustomers")
                            .deny Изменение контрагентов заблокированно
                        .status(v-else)
                            span(
                                v-if="deal.first_freight && deal.first_freight.currenttracking && deal.first_freight.currenttracking.status"
                                v-bind:style="'color: ' + deal.first_freight.currenttracking.status.color"
                                v-bind:title="deal.first_freight.currenttracking.status.name"
                            ) {{deal.first_freight.currenttracking.status.name}}
                            span(v-else title="Не установлен") Не установлен

                    .md-layout-item.entity-head-right
                        .date
                            span(v-if="deal.id && deal.created_at") {{ 'Создана: ' + moment(deal.created_at).tz($root.userTimezone).format('DD.MM.YYYY HH:mm')}}
                            span(v-if="deal.id && deal.updated_at") {{ 'Обновлена: ' + moment(deal.updated_at).tz($root.userTimezone).format('DD.MM.YYYY HH:mm')}}
                        md-button.md-primary.md-icon-button.md-dense.close.small(@click="save" v-if="!blockDeal")
                            md-icon check
                            md-tooltip(md-direction="bottom" md-delay="500") Сохранить
                        md-button.md-icon-button.md-dense.close.small(v-on:click.stop.pervent="back")
                            md-icon close
                            md-tooltip(md-direction="bottom" md-delay="500") Отменить
                            
                .md-layout-item.md-layout.prices
                    .md-layout-item.md-alignment-top-left.md-size-65

                        .price-debtors(v-if="deal && deal.first_freight")
                            .left
                                .price( v-if="deal.id && deal.first_freight.full_price" ref="fullPrice" v-show="!customPrice" v-bind:class="{'custom': (deal.first_freight && !!deal.first_freight.custom_price_active)}")
                                    //Редактирование отключено т.к. оно теперь есть в детализированном виде
                                    //.price-value(v-on:click.stop.pervent="showCustomPrice")
                                    .price-value
                                        .label Цена:
                                        .value {{ formatPrice(deal.first_freight.price) }} руб.

                                    md-button.md-icon-button.md-dense.close.small.full-price-btn.recalc(v-on:click.stop.pervent="recalcPrice" v-bind:disabled="!canEditPrice")
                                        i.fas.fa-sync-alt
                                        md-tooltip(md-direction="top" md-delay="500") Пересчитать цену
                                    
                                    z-tool-menu(v-if="deal && deal.id" v-bind:active="showFullPrice" left)
                                        template(slot="action" slot-scope="scope")
                                            md-button.md-icon-button.md-dense.close.small.full-price-btn(v-on:click.stop.pervent="toggleFullPrice")
                                                i.fas.fa-chevron-down
                                                md-tooltip(md-direction="bottom" md-delay="500") Показать детализированную цену
                                        price-list(
                                            v-if="deal && deal.id"
                                            v-bind:payers="selectablePayers"
                                            v-bind:storage="storage"
                                            v-bind:deal="deal"
                                            v-bind:freight="deal.first_freight"
                                            v-bind:payer-id="parseInt(deal.payer_id)"
                                            v-bind:blocked="!canEditPrice"
                                            v-on:recalc="recalcStoragePrice"
                                            v-on:update="setPrice"
                                        )

                                .price.input-price-container(v-show="deal && deal.first_freight && customPrice")
                                    .input-price
                                        label Цена:
                                        input(
                                            v-model="deal.first_freight.price"
                                            type="number" name="freight_price" id="freight_price"
                                            v-validate="{'decimal': [2, '.'], min_value: (isUserAdmin ? 0 : 1)}"
                                            data-vv-name="freight_price" data-vv-scope='price' data-vv-as=" "
                                            class="input-price" ref="customprice" step="0.01")
                                        span руб.
                                        md-button.md-accent.md-icon-button.md-dense.close.small(v-if="customPrice && !!parseInt(deal.first_freight.custom_price_active)" v-on:click.stop.pervent="unsetCustomPrice")
                                            md-icon delete
                                            md-tooltip(md-direction="top" md-delay="500") Удалить
                                        md-button.md-primary.md-icon-button.md-dense.close.small(v-if="customPrice" v-on:click.stop.pervent="setCustomPrice")
                                            md-icon check
                                            md-tooltip(md-direction="top" md-delay="500") Применить
                                        md-button.md-icon-button.md-dense.close.small(v-if="customPrice" v-on:click.stop.pervent="hideCustomPrice")
                                            md-icon close
                                            md-tooltip(md-direction="top" md-delay="500") Отменить
                                    .error(v-if="errors.first('price.freight_price')") {{ errors.first('price.freight_price') }}

                            ZDealStatusChanger(
                                v-if="deal && deal.first_freight && deal.first_freight"
                                v-model="deal.status_id" v-bind:deal-id="deal.id" status-request
                                v-on:update="onDealStatusUpdate"
                                v-bind:disabled="!!(deal.first_freight.route_lists && deal.first_freight.route_lists.length)"
                            )

                            ZDealIssueStatusChanger(
                                v-if="deal && deal.first_freight && deal.first_freight"
                                v-model="deal.status_issue_id" v-bind:deal-id="deal.id"
                                v-bind:disabled-recalc="blockDeal"
                                v-bind:payers="selectablePayers" v-on:recalc="recalcDebtors"
                            )

                    .md-layout-item.md-size-35.md-alignment-center(v-if="deal.id && !dirtyForOperations && paymentMethods")
                        z-input-finance-operation(
                            v-model="deal.operations"
                            v-bind:deal-id="parseInt(deal.id)"
                            v-bind:company-id="parseInt(deal.executor_company_id)"
                            v-bind:price="(deal.first_freight ? parseFloat(deal.first_freight.price) : 0)"
                            v-bind:payers-price="((deal.first_freight && deal.first_freight.full_price && deal.first_freight.full_price.payers) ? deal.first_freight.full_price.payers : {})"
                            v-bind:required-full-price="true"
                            v-on:save="saveFromOperations"
                            v-bind:payers="selectablePayers"
                            v-bind:payment-methods="paymentMethods"
                            v-bind:dirty.sync="isDirty.operations"
                            v-bind:disabled="blockDeal"
                            v-on:remove="recalcDebt"
                        )
                    .md-layout-item.md-size-35.md-alignment-center
                        .operation-dirty-error(v-if="dirtyForOperations") 
                            span Добавление платежей доступно после
                            span сохранения внесённых изменений

                        //autocomplete(
                            v-bind:callback="searchUsers" v-model="deal.responsible_id" v-bind:deafaultObject="deal.responsible" v-bind:disabled="(blockDeal || blockCustomers)"
                            property="login" display-property="login" return="id" label="Ответственный" name="responsible_id" id="responsible_id"
                        //)
                        
            .entity-card-body(v-loader-overlay="progressDealForm")
                flex-tabs(
                    v-bind:tabs="tabs"
                    v-model="activeTab"
                    v-on:change="changeActiveTab"
                    min prevent-input
                )
                
                .md-layout.md-gutter(v-show="activeTab == 'tab-customers'")
                    .md-layout-item.md-alignment-top-left.md-size-50
                        // Отправитель
                        .md-subheading Отправитель
                        sender(
                            ref="sender"
                            v-model="deal.sender"
                            v-bind:customers-ul="customersUL"
                            v-bind:customers-fl="customersFL"
                            v-on:change-contacts="changeContacts"
                            v-bind:block="(blockDeal || blockCustomers)"
                            v-bind:search-by-inn-callback="searchCustomerByInn"
                            v-bind:break-customer-callback="breakCustomer"
                            v-bind:search-customer-by-passport-callback="searchCustomerByPassport"
                            v-bind:dirty.sync="isDirty.sender"

                            v-bind:isUserHasHighPermission="isUserHasHighPermission"
                            v-bind:isUserAgent="isUserAgent"
                            v-bind:isUserAdmin="isUserAdmin"
                            v-bind:isUserManager="isUserManager"

                            v-bind:isDealCanceled="isDealCanceled"
                            v-bind:isIssueToTransfer="isIssueToTransfer"
                            v-bind:isEnteredToStock="isEnteredToStock"
                            v-bind:isIssusedToClient="isIssusedToClient"
                        )
                        delivery-from(
                            ref="deliveryFrom"
                            v-model="deal"
                            v-bind:isUserAgentForm="isUserAgentForm"
                            v-bind:block="(blockDeal || blockCustomers)"
                            v-bind:suggest-address-callback="suggestAddress"
                            v-bind:dirty.sync="isDirty.from"
                            v-bind:payers="selectablePayers"
                            v-bind:can-edit-price="canEditPrice"

                            v-bind:isUserHasHighPermission="isUserHasHighPermission"
                            v-bind:isUserAgent="isUserAgent"
                            v-bind:isUserAdmin="isUserAdmin"
                            v-bind:isUserManager="isUserManager"

                            v-bind:isDealCanceled="isDealCanceled"
                            v-bind:isIssueToTransfer="isIssueToTransfer"
                            v-bind:isEnteredToStock="isEnteredToStock"
                            v-bind:isIssusedToClient="isIssusedToClient"
                        )

                    .md-layout-item.md-alignment-top-left.md-size-50
                        // Получатель
                        .md-subheading Получатель
                        recipient(
                            ref="recipient"
                            v-model="deal.recipient"
                            v-bind:customers-ul="customersUL"
                            v-bind:customers-fl="customersFL"
                            v-on:change-contacts="changeContacts"
                            v-bind:block="(blockDeal || blockCustomers)"
                            v-bind:search-by-inn-callback="searchCustomerByInn"
                            v-bind:break-customer-callback="breakCustomer"
                            v-bind:search-customer-by-passport-callback="searchCustomerByPassport"
                            v-bind:dirty.sync="isDirty.recipient"

                            v-bind:isUserHasHighPermission="isUserHasHighPermission"
                            v-bind:isUserAgent="isUserAgent"
                            v-bind:isUserAdmin="isUserAdmin"
                            v-bind:isUserManager="isUserManager"

                            v-bind:isDealCanceled="isDealCanceled"
                            v-bind:isIssueToTransfer="isIssueToTransfer"
                            v-bind:isEnteredToStock="isEnteredToStock"
                            v-bind:isIssusedToClient="isIssusedToClient"
                        )
                        delivery-to(
                            ref="deliveryTo"
                            v-model="deal"
                            v-bind:block="(blockDeal || blockCustomers)"
                            v-bind:suggest-address-callback="suggestAddress"
                            v-bind:dirty.sync="isDirty.to"
                            v-bind:payers="selectablePayers"
                            v-bind:can-edit-price="canEditPrice"

                            v-bind:isUserHasHighPermission="isUserHasHighPermission"
                            v-bind:isUserAgent="isUserAgent"
                            v-bind:isUserAdmin="isUserAdmin"
                            v-bind:isUserManager="isUserManager"

                            v-bind:isDealCanceled="isDealCanceled"
                            v-bind:isIssueToTransfer="isIssueToTransfer"
                            v-bind:isEnteredToStock="isEnteredToStock"
                            v-bind:isIssusedToClient="isIssusedToClient"
                        )

                    .md-layout-item.md-alignment-top-left.md-size-50
                        .md-subheading Прочие данные
                        applicant(ref="applicant" v-model="deal.applicant_id" v-bind:deal="deal" v-bind:block="(blockDeal || blockCustomers || isIssueToTransfer || isEnteredToStock)" v-bind:dirty.sync="isDirty.applicant")

                        z-select(
                            label="С НДС / без НДС"
                            v-model="deal.executor_company_id"
                            :required="true"
                            name="executor_company_id"
                            id="executor_company_id"
                            v-validate="'required'"
                            v-bind:error="errors.first('executor_company_id') || (isDealHasInvoice || isDealHasAct ? 'У заявки создана Счёт-фактура или Акт, изменение исполнителя невозможно' : null)"
                            v-bind:disabled="(blockDeal || blockCustomers || isDealCompletePayment || !!isDealHasInvoice || !!isDealHasAct)"
                            inline
                            v-bind:dirty.sync="isDirty.executor"
                        )
                            option(
                                v-for="company in companies"
                                v-bind:value="company.id"
                                v-bind:key="company.id"
                                :disabled="parseInt(company.active) == 0 && !isUserAdmin"
                            ) {{ ((parseInt(company.nds)) ? `с НДС ${company.nds_value}%` : 'без НДС') + ' (' + company.name + ')'}}
                    .md-layout-item.md-alignment-top-left.md-size-100
                        .deal__payers-actions
                            .md-subheading Плательщик
                            z-button(v-if="deal.id && deal.id != 'new' && !blockDeal && deal.payer && deal.payer.id" v-on:click.stop.pervent="addPayer" square): md-icon add

                    .deal__payers-container
                        toggle-card.deal__payers-item(heading="Основной плательщик" :visibility="true")
                            z-select(
                                label="Плательщик" name="payer_who" id="payer_who"
                                v-model="deal.payer_type" v-bind:required="true" inline
                                v-validate="'required'" v-bind:error="errors.first('payer_who')" v-bind:data-vv-as="' '"
                                v-bind:disabled="(blockDeal || blockCustomers || isDealCompletePayment || (aviablesPayerTypeLength === 1 && deal.payer_type == 3))"
                                v-bind:dirty.sync="isDirty.payer"
                            )
                                option(v-for="item in payerType" v-bind:value="item.value" v-bind:disabled="item.disabled") {{item.label}}

                            z-select(
                                class="payment-method" label="Способ оплаты" name="payment_method_id" id="payment_method_id"
                                v-model="deal.payment_method_id" v-bind:required="true" inline
                                v-validate="'required'" data-vv-name="payment_method_id" v-bind:data-vv-as="' '"
                                v-bind:error="errors.first('payment_method_id')"
                                v-bind:disabled="(blockDeal || blockCustomers || !!(hasOperationsByPayer(deal.payer ? deal.payer.id : null) && !isUserAdmin))"
                                v-bind:dirty.sync="isDirty.paymentType"
                            )
                                option(v-for="item in paymentMethods" v-bind:value="item.id") {{item.name}}

                            payer(
                                ref="payer"
                                v-model="deal.payer"
                                v-bind:deal="deal"
                                v-bind:who="deal.payer_type"
                                v-bind:customers-ul="payersUL"
                                v-bind:customers-fl="payersFL"
                                v-bind:block="(blockDeal || blockCustomers || isDealCompletePayment)"
                                v-bind:search-by-inn-callback="searchCustomerByInn"
                                v-bind:break-customer-callback="breakCustomer"
                                v-bind:search-customer-by-passport-callback="searchCustomerByPassport"
                                v-bind:dirty.sync="isDirty.payer"
                            )

                        toggle-card.deal__payers-item(
                            v-for="(payer, i) in deal.payers"
                            v-bind:key="('payer-' + i)"
                            v-bind:heading="('Плательщик ' + (i + 2))"
                            v-bind:visibility="payer.visibility"
                        )
                            template(slot="actions"): z-button(v-on:click.stop.pervent="removePayer($event, i)" accent square v-if="!(blockDeal || blockCustomers || !!hasOperationsByPayer(payer.id))"): md-icon close

                            z-select(
                                label="Плательщик" inline
                                v-model="payer.who" :required="true" 
                                v-bind:name="('payer_who-' + i)" v-bind:id="('payer_who-' + i)"
                                v-validate="'required'" v-bind:error="errors.first(('payer_who-' + i))" v-bind:data-vv-as="' '"
                                v-bind:disabled="(blockDeal || blockCustomers || isDealCompletePayment || (aviablesPayerTypeLength === 1 && payer.who == 3) || !!hasOperationsByPayer(payer.id)) && !isUserAdmin"
                                v-bind:dirty.sync="isDirty.payer"
                            )
                                option(v-for="item in payerType" v-bind:value="item.value" v-bind:disabled="item.disabled") {{item.label}}

                            z-select(
                                v-if="payer && payer.value && payer.value.pivot"
                                class="payment-method" label="Способ оплаты" v-bind:name="('payment_method_id-' + i)" v-bind:id="('payment_method_id-' + i)"
                                v-model="payer.value.pivot.payment_method_id" v-bind:required="true" inline
                                v-validate="'required'" v-bind:data-vv-as="' '"
                                v-bind:error="errors.first(('payment_method_id-' + i))"
                                v-bind:disabled="(blockDeal || blockCustomers || !!hasOperationsByPayer(payer.id)) && !isUserAdmin"
                                v-bind:dirty.sync="isDirty.payer"
                            )
                                option(v-for="item in paymentMethods" v-bind:value="item.id") {{item.name}}

                            payer(
                                v-if="deal.payers && deal.payers.length"
                                
                                ref="payer-item"
                                v-model="payer.value"
                                v-bind:deal="deal"
                                v-bind:who="payer.who"
                                v-bind:customers-ul="payersUL"
                                v-bind:customers-fl="payersFL"
                                v-bind:block="(blockDeal || blockCustomers || isDealCompletePayment || !!hasOperationsByPayer(payer.id))"
                                v-bind:search-by-inn-callback="searchCustomerByInn"
                                v-bind:break-customer-callback="breakCustomer"
                                v-bind:search-customer-by-passport-callback="searchCustomerByPassport"
                                v-bind:dirty.sync="isDirty.payer"
                            )
                            
                freight(
                    v-show="activeTab == 'tab-freight'" ref="freight"
                    v-model="deal.first_freight"
                    v-bind:deal="deal"
                    v-bind:block="(blockDeal)"
                    v-bind:dirty.sync="isDirty.freight" 
                    v-bind:payers="selectablePayers",
                    v-bind:fromLuw="fromLuw"
                    v-bind:toLuw="toLuw"
                    v-bind:isDealDirty="dirty"

                    v-bind:isUserHasHighPermission="isUserHasHighPermission"
                    v-bind:isUserAgent="isUserAgent"
                    v-bind:isUserAdmin="isUserAdmin"
                    v-bind:isUserManager="isUserManager"

                    v-bind:isDealCanceled="isDealCanceled"
                    v-bind:isIssueToTransfer="isIssueToTransfer"
                    v-bind:isEnteredToStock="isEnteredToStock"
                    v-bind:isIssusedToClient="isIssusedToClient"
                )

                ZFreightTracking(ref="tracking" 
                    v-on:change="changeCurrentTracking"
                    v-on:change-deal-status="onDealUpdate"
                    v-bind:deal="deal" 
                    v-bind:freight="deal.first_freight" 
                    v-bind:load="(activeTab == 'tab-tracking')" 
                    v-show="(activeTab == 'tab-tracking')" 
                    v-bind:block="blockDeal"
                )

                docs(
                    v-if="deal && deal.id && deal.id !== 'new'" v-show="activeTab == 'tab-docs'"
                    v-bind:deal="deal" v-bind:load="(activeTab == 'tab-docs')"
                    v-bind:freight="deal.first_freight"
                    v-bind:block="blockDeal" v-on:update="updateDocuments"
                    v-bind:finance="deal.operations"
                )

                tasks(v-show="activeTab == 'tab-tasks'" v-bind:load="activeTab == 'tab-tasks'" v-bind:deal="deal")

                .tab-content(v-if="deal.id && activeTab == 'tab-comments'")
                    comments-and-logs(:entity_id="deal.id" entity="deals" module="deals")

            .entity-card-footer(v-if="isUserAgent || isUserAdmin" v-show="ticketsPrintData.trackingNumber")
                ticket-print(
                    v-if="(ticketsPrintData.trackingNumber && parseInt(ticketsPrintData.seatsNumber) > 0 && ticketsPrintData.sender && ticketsPrintData.recipient)"
                    ref="ticketprint"
                    v-bind:printers="printers"
                    v-bind:trackingNumber="ticketsPrintData.trackingNumber"
                    v-bind:date="ticketsPrintData.date"
                    v-bind:fromCity="ticketsPrintData.fromCity"
                    v-bind:toCity="ticketsPrintData.toCity"
                    v-bind:fromAddress="ticketsPrintData.fromAddress"
                    v-bind:toAddress="ticketsPrintData.toAddress"
                    v-bind:seatsNumber="parseInt(ticketsPrintData.seatsNumber)"
                    
                    v-bind:sender="ticketsPrintData.sender"
                    v-bind:recipient="ticketsPrintData.recipient"
                    v-bind:temperature-regime="ticketsPrintData.tempReg"
                )
                .print-btn(v-on:click.stop.pervent="printDoc(deal.id, 'stock_note')" v-if="isUserAgent && deal && deal.id && deal.first_freight && deal.first_freight.from_stock_signature") Складская записка
                .shipment.md-caption.bottom(v-if="isUserAgent")
                    .deny(v-if="!canIssue") Выдача запрешена
                    md-button.md-dense.md-accent.close.small(v-if="canIssue" v-on:click.stop.pervent="issue") Выдать груз
</template>
<script>
    import autocomplete from '@/components/autocomplete';
    import FlexTabs     from '@/components/FlexTabs';
    import ToggleCard   from '@/components/ToggleCard';
    import ZFreightTracking     from '@/components/ZFreightTracking.vue';
    import ZInputFinanceOperation from '@/components/ZInputFinanceOperation.vue';
    import Sender       from './components/Sender.vue';
    import Recipient    from './components/Recipient.vue';
    import Payer        from './components/Payer.vue';
    import Applicant    from './components/Applicant.vue';
    import DeliveryFrom from './components/DeliveryFrom.vue';
    import DeliveryTo   from './components/DeliveryTo.vue';
    import Freight      from './components/Freight.vue';
    import Docs         from './components/Docs.vue';
    import Tasks        from './components/Tasks.vue';
    import ZSelect      from '@/components/ZSelect';
    import ZInput       from '@/components/ZInput';
    import commentsAndLogs from '@/components/CommentsAndLogs';
    import TicketPrint from '@/components/TicketPrint';
    import ZDealStatusChanger from '@/components/ZDealStatusChanger';
    import ZDealIssueStatusChanger from '@/components/ZDealIssueStatusChanger';
    import ZButton   from '@/components/ZButton';
    import ZToolMenu from '@/components/ZToolMenu';
    import PriceList from './components/PriceList';
    export default {
        components: {
            autocomplete, FlexTabs, ToggleCard, ZSelect, commentsAndLogs, TicketPrint, ZInputFinanceOperation, ZInput, ZButton, PriceList,
            Sender, Recipient, Payer, Applicant, DeliveryFrom, DeliveryTo, Freight, ZFreightTracking, Docs, Tasks, ZDealStatusChanger, ZToolMenu,
            ZDealIssueStatusChanger
        },
        data() {
            return {
                changeStatusDialog: false,
                changeStatusMessage: null,

                MainDealForm: true, //Необходимо для поиска компонента в древе родителей
                showFullPrice: false,
                loading: false,
                payers: [],
                deal: {},
                defaultDeal: {
                    id: null,
                    created_at: null,
                    updated_at: null,
                    sort: 100,
                    description: null,
                    executor_company_id: null,
                    responsible_id: null,
                    from_city_id: null,
                    to_city_id: null,
                    from_stock_id: null,
                    to_stock_id: null,
                    from_address_id: null,
                    to_address_id: null,
                    forwarding_date_from: new Date(),
                    forwarding_date_to: new Date(),
                    from_signature: null,
                    from_stock_signature: null,
                    to_signature: null,
                    from_signature_date: null,
                    from_stock_signature_date: null,
                    to_signature_date: null,
                    applicant_id: null,
                    sender_id: null,
                    recipient_id: null,
                    payer_id: null,
                    payer_type: null,
                    status_id: null,
                    traking_number: null,
                    price: null,
                    forwarder_from_id: null,
                    forwarder_to_id: null,
                    full_price: null,
                    blocked: 0,
                    route_lists: [],
                    route_list_to: null,
                    route_list_from: null,
                    delivery_method_from: 1,
                    delivery_method_to: 1,
                    payment_method_id: null,
                    forwarding_payer_id_from: null,
                    forwarding_payer_id_to: null,
                    from_address: {
                        id: null,
                        value: {},
                        address: null,
                        description: null,
                        type_id: 1,
                        city_id: null,
                        value: {
                            city_fias_id: null
                        }
                    },
                    to_address: {
                        id: null,
                        value: {},
                        address: null,
                        description: null,
                        type_id: 1,
                        city_id: null,
                        value: {
                            city_fias_id: null
                        }
                    },
                    from_stock: {
                        id: null,
                        name: null,
                        description: null,
                        sort: 100,
                        city_id: null,
                        freight_count: 0
                    },
                    to_stock: {
                        id: null,
                        name: null,
                        description: null,
                        sort: 100,
                        city_id: null,
                        freight_count: 0
                    },
                    first_freight: {
                        id: null,
                        created_at: null,
                        updated_at: null,
                        description: null,
                        storekeeper_comment: null,
                        size: null,
                        size_units: 'м',
                        status_id: null,
                        deal_id: null,
                        tracking_id: null,
                        traking_number: null,
                        weight: null,
                        height: null,
                        length: null,
                        width: null,
                        oversize: 0,
                        full_oversize: 0,
                        oversize_size: 0.0,
                        oversize_weight: 0.0,
                        seats_number: null,
                        doom: 0,
                        doom_make: 0,
                        factory_package: null,
                        price: 0,
                        full_price: null,
                        sort: 100,
                        from_signature: null,
                        from_stock_signature: null,
                        to_signature: null,
                        custom_price: null,
                        custom_price_active: 0,
                        currenttracking: null,
                        acceptedtracking: null,
                        issuedtracking: null,
                        route_lists: [],
                        acceptedtracking: null,
                        currenttracking: null,
                        from_luw_hours:   0,
                        from_luw_workers: 0,
                        to_luw_hours:   0,
                        to_luw_workers: 0,
                        from_manipulator_hours: 0,
                        to_manipulator_hours: 0
                    },
                    documents: [],
                    contacts: [],
                    forwarder_from: null,
                    forwarder_to: null,
                    applicant: {
                        id: null,
                        hid: null,
                        created_at: null,
                        updated_at: null,
                        name: null,
                        type: 1,
                        inn: null,
                        kpp: null,
                        passport_number: null,
                        checking_account: null,
                        correspondent_account: null,
                        bic: null,
                        bank: null,
                        sort: 100,
                        phone: null,
                        email: null,
                        nds: 0,
                        attached_contacts: [],
                        addresses: [],
                        contacts: [],
                        allow_edit: false,
                        allow_edit_kpp: false,
                        fe_attached_contacts: [],
                        can_issue_freight: 0,
                        debt: 0
                    },
                    sender: {
                        id: null,
                        hid: null,
                        created_at: null,
                        updated_at: null,
                        name: null,
                        type: 1,
                        inn: null,
                        kpp: null,
                        passport_number: null,
                        checking_account: null,
                        correspondent_account: null,
                        bic: null,
                        bank: null,
                        sort: 100,
                        phone: null,
                        email: null,
                        nds: 0,
                        attached_contacts: [],
                        addresses: [],
                        contacts: [],
                        allow_edit: false,
                        allow_edit_kpp: false,
                        fe_attached_contacts: [],
                        can_issue_freight: 0,
                        debt: 0
                    },
                    recipient: {
                        id: null,
                        hid: null,
                        created_at: null,
                        updated_at: null,
                        name: null,
                        type: 1,
                        inn: null,
                        kpp: null,
                        passport_number: null,
                        checking_account: null,
                        correspondent_account: null,
                        bic: null,
                        bank: null,
                        sort: 100,
                        phone: null,
                        email: null,
                        nds: 0,
                        attached_contacts: [],
                        addresses: [],
                        contacts: [],
                        allow_edit: false,
                        allow_edit_kpp: false,
                        fe_attached_contacts: [],
                        can_issue_freight: 0,
                        debt: 0
                    },
                    payer: {
                        id: null,
                        hid: null,
                        created_at: null,
                        updated_at: null,
                        name: null,
                        type: 1,
                        inn: null,
                        kpp: null,
                        passport_number: null,
                        checking_account: null,
                        correspondent_account: null,
                        bic: null,
                        bank: null,
                        sort: 100,
                        phone: null,
                        email: null,
                        nds: 0,
                        attached_contacts: [],
                        addresses: [],
                        contacts: [],
                        allow_edit: false,
                        allow_edit_kpp: false,
                        fe_attached_contacts: [],
                        can_issue_freight: 0,
                        debt: 0
                    },
                    payers: [],
                    tasks: [],
                    operations: [],
                    responsible: null,
                    executor: {
                        id: null,
                        name: null,
                        inn: null,
                        kpp: null,
                        bak: null,
                        checking_account: null,
                        correspondent_account: null,
                        initials: null,
                        position: null,
                        on_base: null,
                        bik: null,
                        bank_name: null,
                        email: null,
                        phone: null,
                        nds: 0,
                        sort: 100,
                        is_default: 0,
                        addresses: []
                    },
                    status: {
                        id: null,
                        name: null,
                        description: null,
                        sort: 100,
                        type: "default",
                        color: "#2196f3"
                    },
                    from_city: null,
                    to_city: null,
                    contacts: {
                        sender: [],
                        recipient: [],
                        payer: []
                    },
                },
                defaultCustomer: {
                    id: null,
                    hid: null,
                    created_at: null,
                    updated_at: null,
                    name: null,
                    type: 1,
                    inn: null,
                    kpp: null,
                    passport_number: null,
                    checking_account: null,
                    correspondent_account: null,
                    bic: null,
                    bank: null,
                    sort: 100,
                    phone: null,
                    email: null,
                    nds: 0,
                    attached_contacts: [],
                    addresses: [],
                    contacts: [],
                    allow_edit: false,
                    allow_edit_kpp: false,
                    can_issue_freight: 0,
                    debt: 0,
                    pivot: {
                        payment_method_id: null
                    }
                },
                who: {
                    payer: 1
                },
                customPrice: false,
                prevPrice: 0,
                activeTab: 'tab-customers',
                tabs: [
                    {name: "tab-customers", label: "Контрагенты",   error: false, refs: ['sender', 'recipient', 'payer', 'deliveryFrom', 'deliveryTo']},
                    {name: "tab-freight",   label: "Груз и услуги", error: false, refs: ['freight']},
                    {name: "tab-tracking",  label: "Трекинг",       error: false},
                    {name: "tab-docs",      label: "Документы",     error: false},
                    {name: "tab-tasks",     label: "Задачи",        error: false},
                    {name: "tab-comments",  label: "История",       error: false},
                ],
                tabErrors: {
                    sender:       true,
                    deliveryFrom: true,
                    recipient:    true,
                    deliveryTo:   true,
                    payer:        true,
                    applicant:    true,
                    freight:      true
                },
                isDirty: {
                    paymentType: false,
                    operations: false,
                    sender: false,
                    recipient: false,
                    payer: false,
                    payerType: false,
                    applicant: false,
                    from: false,
                    to: false,
                    executor: false,
                    freight: false
                },
                payerTypes: [
                    {label: 'Отправитель', value: 1, removable: true, disabled: false},
                    {label: 'Получатель',  value: 2, removable: true, disabled: false},
                    {label: 'Третье лицо', value: 3, removable: false, disabled: false},
                ],
                defaultLuw: {
                    id: null,
                    min_time: 0,
                    price: 0,
                    city_id: null,
                    zone_id: null,
                    type: 0
                },
                fromLuw: {
                    id: null,
                    min_time: 0,
                    price: 0,
                    city_id: null,
                    zone_id: null,
                    type: 0
                },
                toLuw: {
                    id: null,
                    min_time: 0,
                    price: 0,
                    city_id: null,
                    zone_id: null,
                    type: 0
                }                
            }
        },
        created() {
            this.clear();
            this.init();
            this.listeners();
        },
        mounted() {
            this.closeListen();
        },
        methods: {
            closeListen() {
                this.closePriceListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.fullPrice && !this.$refs.fullPrice.contains(e.target)) {
                        document.removeEventListener('click', this.closePriceListener, false);
                        this.showFullPrice = false;
                    }
                });
            },
            clear() {
                this.deal = JSON.parse(JSON.stringify(this.defaultDeal));
            },
            init() {
                this.$store.commit('showSnackbar', ['Загрузка заявки', 3000]);
                this.$store.commit('openRightPanel');
                this.$store.commit('adaptiveSizePanel');
                this.getPaymentMethods();
                this.getStocks();
                this.getFromStocks();
                this.getToStocks();
                this.getAddressTypes();
                this.getCompanies();
                this.validateClear();
                
                //получаем ФЛ и ЮЛ для автоподстановки
                //if (!this.customersFL || !this.customersFL.count) this.$store.dispatch('customers/getFLCustomers', {perPage: 20, filter: {model: [["passport_number", "!=", ""], "and", ["passport_number", "!=", "null"], "and", ["type", "=", 2]]}});
                //if (!this.customersUL || !this.customersUL.count) this.$store.dispatch('customers/getULCustomers', {perPage: 20, filter: {model: [["inn", "!=", ""], "and", ["inn", "!=", "null"], "and", ["type", "=", 1]]}});

                return this.initDeal();
            },
            initDeal() {
                return this.getDeal(false).then(deal => {
                    if (deal && deal.first_freight && deal.first_freight.traking_number) this.$store.commit('setTitle', ('Заявки | ' + deal.first_freight.traking_number));
                    
                    //softUpdate закомментировал т.к. ломает логику контактных лиц контрагентов (не работает поле label)
                    //this.helpers.object.softUpdate(this.deal, deal).then(() => this.validateClear());
                    this.deal = Object.assign({}, deal);
                    //Печатаем документы и этикетки, если это требуется
                    if (this.$route.query && this.$route.query.print) {
                        try {
                            this.$nextTick(() => { //nextTick нужен чтобы успело посчитаться computed поле ticketsPrintData (данные для печати этикеток)
                                this.printDoc(deal.id, 'stock_note'); //Печатаем складскую записку
                                if (!this.$refs || !this.$refs.ticketprint) return
                                this.$refs.ticketprint.print(); //Печатаем этикетки
                                //Убираем из URL флаг печати
                                let query = Object.assign({}, this.$route.query);
                                delete query.print;
                                this.$router.replace({name: this.$route.name, params: this.$route.params, query: Object.assign({}, query)});
                            });
                        } catch (e) {
                            this.$store.commit('showSnackbar', ['Произошла ошибка печати, проверьте принтер.', 6000, 'error']);
                        }
                    }
                    this.dirtyClear();
                    this.$nextTick(() => this.getLuwParams());

                    return this.deal;
                });
            },
            /**
             * Получает параметры ПРР для пункта отправления и назначения
             */
            getLuwParams() {
                this.getLuwParamFrom();
                this.getLuwParamTo();
            },
            /**
             * Получает параметры ПРР для пункта отправления
             */
            async getLuwParamFrom() {
                this.fromLuw = Object.assign({}, this.defaultLuw);
                if (parseInt(this.deal.delivery_method_from) === 2 && this.deal.from_address.value.city_fias_id) {
                    const luw = await this.getLuwParam(this.deal.from_address.value.city_fias_id);
                    if (luw && luw.id) this.fromLuw = Object.assign({}, luw);
                }
            },
            /**
             * Получает параметры ПРР для пункта назначения
             */
            async getLuwParamTo() {
                this.toLuw = Object.assign({}, this.defaultLuw);
                if (parseInt(this.deal.delivery_method_to) === 2 && this.deal.to_address.value.city_fias_id) {
                    const luw = await this.getLuwParam(this.deal.to_address.value.city_fias_id);
                    if (luw && luw.id) this.toLuw = Object.assign({}, luw);
                }
            },
            /**
             * Получает параметры ПРР по ФИАСу города
             * Вернёт начение для города, если его нет,
             * то для направления этого города
             * @param {string} CityId - ФИАС города
             */
            getLuwParam(CityFias = null) {
                if (!CityFias) return this.defaultLuw;
                return this.$store.dispatch('cost/getLuwByCityFias', CityFias);
            },            
            addPayer(e) {
                e.stopPropagation();
                e.preventDefault();
                if (!this.deal.payers) this.$set(this.deal, 'payers', []);
                let who = this.payerType.find(item => !item.disabled);
                let customer = Object.assign({}, this.deal.defaultCustomer);
                switch (parseInt(who.value)) {
                    case 1: customer = Object.assign({}, this.deal.sender); break;
                    case 2: customer = Object.assign({}, this.deal.recipient); break;
                    case 3: customer = Object.assign({}, this.deal.defaultCustomer); break;
                    default: customer = Object.assign({}, this.deal.defaultCustomer); break;
                }

                this.$set(this.deal.payers, parseInt(this.deal.payers.length), Object.assign({}, {
                    id: null,
                    who: who.value,
                    visibility: true,
                    value: Object.assign({}, this.setCustomerPaymentMethod(customer))
                }));
            },
            removePayer(e, i) {
                e.stopPropagation();
                e.preventDefault();
                this.$root.$emit('z-alert', 'Вы уверены, что хотите удалить плательщика?', null, () => {
                    this.deal.payers.splice(i, 1);
                });
            },
            setCustomerPaymentMethod(customer) {
                if (!customer.pivot) customer.pivot = {};
                if (!customer.pivot.payment_method_id) customer.pivot.payment_method_id = parseInt(this.deal.payment_method_id);
                return customer;
            },
            resolvePayerNDS() {
                if (!this.companies || !this.companies.length || (this.deal.id && this.deal.id != 'new') || this.isDirty.executor) return;
                let executor = null;
                /* Это не треубется т.к. компания теперь работает только с НДС
                if (this.deal && this.deal.payer && this.deal.payer.id && this.deal.payer.id != 'new') {
                    let nds = (this.deal && this.deal.payer && parseInt(this.deal.payer.nds) === 1) ? 1 : 0;
                    executor = this.companies.find(company => (company && company.id && parseInt(company.nds) === parseInt(nds)));
                } else executor = this.companies.find((item, i) => !!parseInt(item.is_default) && !!parseInt(item.active));
                */
                executor = this.companies.find((item, i) => !!parseInt(item.is_default) && !!parseInt(item.active));

                if (executor && executor.id) this.deal.executor_company_id = parseInt(executor.id);
            },
            hasOperationsByPayer(PayerId) {
                if (!PayerId || !this.deal.operations || !this.deal.operations.length) return false
                return !!this.deal.operations.find(item => parseInt(item.customer_id) === parseInt(PayerId));
            },
            toggleFullPrice() {
                this.showFullPrice = !this.showFullPrice;
            },
            recalcDebtors() {
                if (!this.deal || !this.deal.id) return;
                if (!this.dirty) this.recalcDebt();
                else this.$root.$emit(
                    'z-alert',
                    'Пересчитать задолжность плательщиков?<br>Внесённые вами измненеия не сохранятся!',
                    'Изменённые поля выделенны синим цветом.',
                    () => this.recalcDebt()
                );
            },
            recalcDebt() {
                this.$store.dispatch('finance/getDebtByDeal', this.deal.id).then(r => {
                    this.onDealUpdate();
                });
            },

            listeners() {
                this.$root.$on('update-deal-form', deal => {
                    if (this.deal && deal && deal.id && parseInt(this.deal.id) === parseInt(deal.id)) this.onDealUpdate(deal);
                });
                this.$root.$on('update-deal-signature', data => {
                    if (this.deal && parseInt(this.deal.id) === parseInt(data.id)) {
                        this.deal[data.type] = data.signature;
                        this.deal[(data.type + '_date')] = data.date;
                    }
                })
            },
            onDealStatusUpdate(status) {
                if (!status || !status.id) return
                this.deal.status = Object.assign({}, status)
            },
            //Вызывается когда прилетает пуш обновления заявки
            async onDealUpdate(deal = null) {
                if (!deal || !deal.id) deal = await this.getDeal(true)
                if (!deal || !deal.id) return;
                this.helpers.object.softUpdate(this.deal, deal).then(() => {
                    if (this.$refs.freight) this.$refs.freight.updateServicesValues();
                });
                this.dirtyClear();
            },
            //Вызывается при добавлении платёжки
            saveFromOperations() {
                //Если заявка заблокированная то сохраняет её т.к. менеджер этого сделать уже не может
                if (this.blockDeal) this.save();
            },
            save() {
                //Если есть clone_id, значит мы копируем заявку, если при этом есть ещё deal.id,
                //значит форма сейчас загружает данные копируемой заявки и не надо давать возможность её сохранять
                //Как только заявка загрузится, то deal.id будет = null
                if (this.$route.query.clone_id && (this.deal.id || this.deal.first_freight.id)) return;

                this.validate().then(valid => {
                    let hasErrors = false;
                    valid.map(item => {
                        if (!item) hasErrors = true;
                    });
                    if (hasErrors) {
                        this.$store.commit('showSnackbar', ['Форма заполнена некорректно, проверьте все поля формы', 6000, 'error']);
                        return;
                    }

                    this.$store.commit('showSnackbar', ['Сохранение заявки, пожалуйста дождитесь полной загрузки формы...', 6000]);
                    let deal = Object.assign({}, this.deal);
                    if (!deal.payer)     deal.payer     = Object.assign({}, deal.sender);
                    if (!deal.applicant) deal.applicant = Object.assign({}, deal.sender);
                    
                    if (deal.sender         && parseInt(deal.applicant_id) === parseInt(deal.sender.id))    deal.applicant_type = 1;
                    else if (deal.recipient && parseInt(deal.applicant_id) === parseInt(deal.recipient.id)) deal.applicant_type = 2;
                    else if (deal.payer     && parseInt(deal.applicant_id) === parseInt(deal.payer.id))     deal.applicant_type = 3;
                    else deal.applicant_type = 1;

                    if (this.deal.payers && Array.isArray(this.deal.payers) && this.deal.payers.length)
                        this.deal.payers.map(payer => {
                            if (parseInt(payer.who) === 1) payer.id = parseInt(deal.sender.id);
                            else if (parseInt(payer.who) === 2) payer.id = parseInt(deal.recipient.id);
                            else if (parseInt(payer.who) === 3 && payer.value && payer.value.id) payer.id = parseInt(payer.value.id);
                            payer.type = parseInt(payer.who);
                        });
                    else this.deal.payers = [];

                    if (this.isUserAgentForm) this.saveAsAgent(deal);
                    else this.saveAsManager(deal);
                });
            },
            saveAsManager(deal) {
                let data = {
                    deal:    deal,
                    freight: Object.assign({}, this.deal.first_freight),
                    service: Object.assign({}, this.deal.first_freight.service),
                };
                this.$store.commit('showProgressBar', 'load-deal-card');
                return this.$store.dispatch('deals/saveDeal', data).then(async deal => {
                    if (!deal || !deal.id) return;
                    if (this.deal && (!this.deal.id || this.deal.id == 'new')) this.$router.push({name: 'DealNew', params: {id: deal.id}});
                    else await this.onDealUpdate();
                    this.$store.commit('showSnackbar', ['Заявка успешно сохранена, обновление формы...', 6000, 'success']);
                }).finally(() => {
                    this.$nextTick(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                });
            },
            saveAsAgent(deal) {
                this.$refs.deliveryFrom.doAgentCapture().then(signature => {
                    if (this.loading) return;
                    this.loading = true;
                    //Подпись на складе подписывать не нужно.
                    //deal.from_stock_signature = signature;
                    deal.from_signature = signature;

                    let data = {
                        deal:    deal,
                        freight: Object.assign({}, this.deal.first_freight),
                        service: Object.assign({}, this.deal.first_freight.service),
                        add_tracking: (!this.deal.id || this.deal.id == 'new'), //добавляем трекинг, если это новая заявка
                        manager_accepted: (!this.deal.id || this.deal.id == 'new') //Показываем беку, что это новая заявка, и что она принимается представителем
                    };

                    this.$store.commit('showProgressBar', 'load-deal-card');
                    return this.$store.dispatch('deals/saveDeal', data).then(async deal => {
                        if (!deal || !deal.id) return this.$store.commit('showSnackbar', ['Ошибка сохранения. Перезагрузите страницу и попробуйте сохранить повторно.', 6000, 'error']);
                        if (this.deal && (!this.deal.id || this.deal.id == 'new')) { //Если заявка новая
                            await this.createDocument(deal.id, ['receipt']); //Создаём экспедиторская расписку

                            //Добавляем флаг печати в query и отправляем пользователя на форму созданной заявки
                            let query = (this.$route.query) ? Object.assign({}, this.$route.query) : {};
                            query.print = true;
                            this.$router.push({name: 'DealNew', params: {id: deal.id}, query: Object.assign({}, query)});
                        } else await this.onDealUpdate();

                        this.$store.commit('showSnackbar', ['Заявка успешно сохранена, обновление формы...', 6000, 'success']);
                    }).finally(() => {
                        this.loading = false;
                        this.$store.commit('hideProgressBar', 'load-deal-card');
                    });
                    
                }, error => this.$store.commit('showSnackbar', ['Ошибка подписи.', 6000, 'error'])).catch(() => {
                    this.loading = false;
                    this.$store.commit('showSnackbar', ['Ошибка подписи.', 6000, 'error']);
                });
            },
            createDocument(dealId, docType) {
                return this.$store.dispatch('deals/postDocument', {
                    deal_id: dealId, user_id: this.user.id, agent_id: null, documents: Object.assign([], docType)
                });
            },
            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
                this.tabs.map(item => {
                    item.error = false;
                    if (item.refs && item.refs.length) item.refs.map(ref => {
                        if (this.$refs[ref]) this.$refs[ref].validateClear();
                    });
                });
                Object.keys(this.tabErrors).map(i => this.tabErrors[i] = true);
            },
            validate(refs) {
                if (!refs) refs = [
                    'sender',
                    'deliveryFrom',
                    'recipient',
                    'deliveryTo',
                    'payer',
                    'applicant',
                    'freight'
                ];
                let ValidPromises = [], invalidTabs = [];

                ValidPromises.push(this.$validator.validateAll().then(valid => {
                    if (!valid) invalidTabs.push('tab-customers');
                    return valid;
                }));

                Object.values(refs).map(ref => {
                    ValidPromises.push(this.$refs[ref].validate().then(valid => {
                        if (!valid) this.tabErrors[ref] = false;
                        else this.tabErrors[ref] = true;
                        let tab = 'tab-' + ref;
                        if ((['sender','recipient', 'payer', 'applicant', 'deliveryFrom', 'deliveryTo'].indexOf(ref)+1)) tab = 'tab-customers';
                        if (!valid) invalidTabs.push(tab);

                        return valid;
                    }));
                });

                return Promise.all(ValidPromises).then(valid => {
                    this.tabs.map(item => {
                        if ((invalidTabs.indexOf(item.name)+1)) {
                            item.error = true;
                            this.$store.commit('showSnackbar', ['Некорректно заполнен раздел "' + item.label + '"', 6000, 'error']);
                        } else item.error = false;
                    });
                    return valid;
                });
            },
            prepareDeal(deal) {
                if (!deal) return this.$store.commit('showSnackbar', ['Ошибка загрузки заявки. Пожалуйста обновите страницу.', 12000, 'error']);

                deal.delivery_method_from = (deal && deal.delivery_method_from) ? parseInt(deal.delivery_method_from) : 1;
                deal.delivery_method_to   = (deal && deal.delivery_method_to)   ? parseInt(deal.delivery_method_to)   : 1;
                deal.payment_method_id    = (deal && deal.payment_method_id)    ? parseInt(deal.payment_method_id)    : null;
                deal.payer_type           = (deal && deal.payer_type) ? parseInt(deal.payer_type) : 1;
                deal.custom_forward_price_from = (deal.custom_forward_price_from == null) ? null : parseInt(deal.custom_forward_price_from);
                deal.custom_forward_price_to   = (deal.custom_forward_price_to   == null) ? null : parseInt(deal.custom_forward_price_to);

                if (parseInt(deal.applicant_id)      === parseInt(deal.sender_id))    deal.applicant_type = 1;
                else if (parseInt(deal.applicant_id) === parseInt(deal.recipient_id)) deal.applicant_type = 2;
                else if (parseInt(deal.applicant_id) === parseInt(deal.payer_id))     deal.applicant_type = 3;
                else deal.applicant_type = 1;
                
                if (!deal.from_address) deal.from_address = JSON.parse(JSON.stringify(this.defaultDeal.from_address));
                if (!deal.to_address)   deal.to_address   = JSON.parse(JSON.stringify(this.defaultDeal.to_address));

                if (!deal.from_stock) deal.from_stock = JSON.parse(JSON.stringify(this.defaultDeal.from_stock));
                if (!deal.to_stock)   deal.to_stock   = JSON.parse(JSON.stringify(this.defaultDeal.to_stock));

                if (deal && deal.first_freight && deal.first_freight.full_price && typeof deal.first_freight.full_price == 'string')
                    deal.first_freight.full_price = JSON.parse(deal.first_freight.full_price);

                let Payers = Object.assign([], deal.payers), PayersRes = [];
                deal.payers = [];
                if (Payers && Payers.length) Payers.map(Payer => {
                    let who = null;
                    if (parseInt(Payer.id)      === parseInt(deal.sender_id))    who = 1;
                    else if (parseInt(Payer.id) === parseInt(deal.recipient_id)) who = 2;
                    else who = 3;

                    if (Payer.pivot && Payer.pivot.payment_method_id) Payer.pivot.payment_method_id = parseInt(Payer.pivot.payment_method_id);

                    PayersRes.push({
                        id: Payer.id,
                        who: who,
                        visibility: true,
                        value: Object.assign({}, Payer)
                    });
                   deal.payers = Object.assign([], PayersRes);
                });

                return deal;
            },
            cloneDeal(id) {
                return this.$store.dispatch('deals/getDealById', id).then(deal => {
                    deal = this.prepareDeal(deal);
                    deal.price = 0;
                    deal.full_price = Object.assign({}, {});
                    deal.custom_price = 0;
                    deal.custom_price_active = 0;
                    deal.traking_number = null;
                    deal.status_id = null;
                    deal.status = Object.assign({}, {});
                    deal.to_signature = null;
                    deal.from_signature = null;
                    deal.from_stock_signature = null;
                    deal.to_signature_date = null;
                    deal.from_signature_date = null;
                    deal.from_stock_signature_date = null;
                    deal.id = null;

                    return deal;
                });
            },
            getDeal(hideLoad) {
                if (!this.$route.params || !this.$route.params.id || this.$route.params.id == 'new') {
                    if (this.$route.query && this.$route.query.clone_id) { //Если идёт клонирование заявки
                        this.$store.commit('showProgressBar', 'load-deal-card');
                        return this.cloneDeal(this.$route.query.clone_id).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                    } else return new Promise((resolve, reject) => {
                        let deal = JSON.parse(JSON.stringify(this.defaultDeal));
                        if (this.isUserAgentForm) {
                            deal.delivery_method_from = 1;
                            if (this.userStocks && this.userStocks.length) deal.from_stock_id = this.userStocks.find(stock => !!stock);
                        }
                        resolve(deal);
                    });
                } else {
                    this.$store.commit('showProgressBar', 'load-deal-card');
                    return this.$store.dispatch('deals/getDealById', this.$route.params.id).then(deal => {
                        return this.prepareDeal(deal);
                    }).finally(() => {
                        this.$nextTick(() => {
                            this.$store.commit('hideProgressBar', 'load-deal-card');
                        });
                    });
                }
            },
            getCompanies() {
                return this.$store.dispatch('companies/getCompanies', { cache: true });
            },
            getStocks() {
                return this.$store.dispatch('stock/getStocks', { cache: true });
            },
            getPaymentMethods() {
                this.$store.dispatch('cost/getPaymentMethods', {page: 1, order_by: 'id', order_type: 'asc', count: 100, cache: true, filter: {model: [['active', '=', 1]]}});
            },
            getFromStocks() {
                return this.$store.dispatch('stock/getFromStocks');
            },
            getToStocks() {
                return this.$store.dispatch('stock/getToStocks');
            },
            getAddressTypes() {
                return this.$store.dispatch('address/getAddressTypes');
            },
            showCustomPrice() {
                if (!this.canEditPrice) return;
                this.customPrice = true;
                if (this.$refs.customprice) this.$nextTick(() => this.$refs.customprice.focus());
                if (this.deal && this.deal.first_freight && this.deal.first_freight.price) this.prevPrice = this.deal.first_freight.price;
            },
            hideCustomPrice() {
                this.customPrice = false;
                if (!this.deal.first_freight.price || parseInt(this.deal.first_freight.price) <= 0) {
                    this.deal.first_freight.price = this.prevPrice;
                    this.prevPrice = 0;
                }
            },
            setCustomPrice() {

                this.$validator.validateAll('price').then(valid => {
                    if (!valid) return;

                    this.$store.commit('showProgressBar', 'load-deal-card');
                    this.$store.dispatch('deals/setCustomPrice', {
                        freight_id: this.deal.first_freight.id, 
                        price:      this.deal.first_freight.price
                    }).then(deal => {
                        this.setPrice(deal);
                        this.$store.commit('showSnackbar', ['Цена успешно обновлена', 6000, 'success']);
                    }).finally(() => {
                        this.$store.commit('hideProgressBar', 'load-deal-card');
                        this.customPrice = false;
                    });
                });
            },
            unsetCustomPrice() {
                this.$store.commit('showProgressBar', 'load-deal-card');
                this.$store.dispatch('deals/unsetCustomPrice', {freight_id: this.deal.first_freight.id}).then(deal => {
                    this.setPrice(deal);
                    this.$store.commit('showSnackbar', ['Цена успешно обновлена', 6000, 'success']);
                }).finally(() => {
                    this.$store.commit('hideProgressBar', 'load-deal-card');
                    this.customPrice = false;
                });
            },
            recalcPrice() {
                this.$store.commit('showProgressBar', 'load-deal-card');
                this.$store.dispatch('deals/recalcCustomPrice', this.deal.id).then(deal => {
                    this.setPrice(deal);
                    this.$store.commit('showSnackbar', ['Цена успешно обновлена', 6000, 'success']);
                }).finally(() => {
                    this.$store.commit('hideProgressBar', 'load-deal-card');
                    this.customPrice = false;
                });
            },
            setPrice(deal) {
                if (!deal || !deal.first_freight) return
                
                this.$set(this.deal.first_freight, 'custom_price', deal.first_freight.custom_price);
                this.$set(this.deal.first_freight, 'price',        deal.first_freight.price);
                this.$set(this.deal.first_freight, 'full_price',   Object.assign({}, deal.first_freight.full_price));
                this.$set(this.deal, 'price', deal.price);
                this.$set(this.deal, 'full_price', Object.assign({}, deal.full_price));    
            },
            recalcStoragePrice() {
                this.$store.commit('showProgressBar', 'load-deal-card');
                return this.$store.dispatch('deals/recalcStoragePrice', this.deal.id).finally(() => {
                    this.$store.commit('hideProgressBar', 'load-deal-card');
                    return this.initDeal();
                });
            },

            searchUsers(search) {
                return this.$store.dispatch('users/getUsers', {
                    page: 1, order_by: 'id', order_type: 'asc', count: 10,
                    filter: {
                        model: [['email', '%', search], 'or', ['login', '%', search]],
                        relation: [['groups', 'code', '=', ['administrators', 'managers']]]
                    }
                });
            },
            selectCustomerByInn(type, customer, inn) {
                customer = Object.assign({}, this.setCustomerPaymentMethod(customer));
                if (this.$refs && this.$refs[type]) this.$refs[type].selectCustomer(inn, customer);
            },
            selectCustomerByPassport(type, customer, passport) {
                customer = Object.assign({}, this.setCustomerPaymentMethod(customer));
                if (this.$refs && this.$refs[type]) this.$refs[type].selectCustomer(passport, customer);
            },
            breakCustomer(type) {
                if (!type || this.deal[type] == undefined || !this.deal[type]) new Promise((resolve, reject) => resolve([]));
                
                //Сбрасываем все поля, кроме типа ИНН и номера паспорта т.к. эти данные пользователь ввёл руками и их трогать не надо
                Object.keys(this.defaultCustomer).map(key => {
                    if (!(['type', 'inn', 'passport_number'].indexOf(key)+1)) this.deal[type][key] = this.defaultCustomer[key];
                })
                this.deal[type]['allow_edit'] = true; //Разрешаем редактирование
                return new Promise((resolve, reject) => resolve([]));
            },
            searchCustomerByInn(inn, type, input) {
                if (!inn || inn.length < 3) return this.breakCustomer(type);
                return this.$store.dispatch('customers/searchAndSuggestCustomers', {search: inn, type: 4}).then(customers => {
                    if (customers && customers.data && Array.isArray(customers.data)) customers = Object.assign([], customers.data)

                    if (!customers || !customers.length) {
                        this.breakCustomer(type);
                        if (input) input.select(inn);
                        return [];
                    }
                    customers.map(item => {
                        item.ul_inn_label  = item.inn  + ': ' + item.name + (item.kpp ? ' (' + item.kpp + ')' : '');
                        item.ul_name_label = item.name + ': ' + item.inn  + (item.kpp ? ' (' + item.kpp + ')' : '');
                        if (!item.id && !item.kpp) item.allow_edit_kpp = true;
                        return item;
                    });

                    if (customers.length && customers[0] && customers[0]['inn'])
                        this.selectCustomerByInn(type, customers[0], customers[0]['inn']);

                    return customers;
                }, r => {
                    this.breakCustomer(type);
                    return [];
                });
            },
            searchCustomerByPassport(passport, type, input) {
                if (!passport || passport.replace(/\D/g, "").length < 4) return new Promise((resolve) => resolve([]));
                return this.$store.dispatch('customers/searchCustomers', { search: passport, type: 2 }).then(customers => {
                    if (customers && customers.data && Array.isArray(customers.data)) customers = Object.assign([], customers.data)

                    if (!customers || !customers.length) {
                        if (passport.replace(/\D/g, "").length === 10) {
                            this.breakCustomer(type);
                            if (input) input.select(passport);
                        }
                        return [];
                    }

                    customers.map(item => {
                        item.fl_passport_label = (item.passport_number ? (item.passport_number + ': ') : '') + item.name;
                        item.fl_name_label = item.name + (item.passport_number ? (': ' + item.passport_number) : '');
                        return item;
                    });

                    if (customers.length && customers[0] && customers[0]['passport_number'])
                        this.selectCustomerByPassport(type, customers[0], customers[0]['passport_number']);

                    return customers;
                }, r => {
                    this.breakCustomer(type);
                    return [];
                });
            },
            suggestAddress(string) {
                return this.$store.dispatch('deals/suggest', { string: string }).then(r => {
                    if (!r) return [];
                    if (r instanceof Array) return r;
                    else {
                        let response = [];
                        response.push(r);
                        return response;
                    }
                });
            },
            /**
             * Синхронизирует список контактов между отправителем и получателем, в случае, если это одно и тоже Юр либо Физ лицо
             * Необходимо т.к. пользователь может добавлять новые КЛ и надо их отображаеть в обоих списках для выбора
             */
            syncContacts() {
                if (!this.deal || !this.deal.sender || !this.deal.recipient || parseInt(this.deal.sender.type) != parseInt(this.deal.recipient.type)) return;
                let type = parseInt(this.deal.sender.type);
                if ((type == 1 || type == 3) && (!this.deal.sender.hid || !this.deal.recipient.hid || this.deal.sender.hid != this.deal.recipient.hid)) return; //Юр лицо
                if (type == 2 && this.deal.sender.passport_number != this.deal.recipient.passport_number) return; //Физ лицо
                
                if (!this.deal.sender.contacts || !this.deal.recipient.contacts || (!this.deal.sender.contacts.length && !this.deal.recipient.contacts.length)) return;
                if (JSON.stringify(this.deal.sender.contacts) == JSON.stringify(this.deal.recipient.contacts)) return;

                let SenderContacts    = Object.assign([], this.deal.sender.contacts),
                    RecipientContacts = Object.assign([], this.deal.recipient.contacts),
                    TempContacts      = [],
                    UniqueContacts    = [],
                    ResultContacts    = [];

                TempContacts = TempContacts.concat(SenderContacts).concat(RecipientContacts);
                TempContacts.map(contact => {
                    if (!(UniqueContacts.indexOf(contact.phone)+1)) {
                        UniqueContacts.push(contact.phone);
                        ResultContacts.push(contact);
                    }
                });

                this.deal.sender.contacts    = Object.assign([], ResultContacts);
                this.deal.recipient.contacts = Object.assign([], ResultContacts);
            },
            changeContacts(type, contacts) {
                this.syncContacts();
            },
            printDoc(id, type) {
                let url = this.endpoint + '/print/' + type + '?deal_id=' + id + '&user_id=' + this.user.id
                window.open(url, '_blank');
            },
            getIssueStatus() {
                return this.$store.dispatch('storekeepers_stocks/getTrackingStatuses', {
                    filter: {model: [['code', '=', 'storekeeper_issued_to_client']]}
                }).then(statuses => {
                    return statuses.find(item => item.code == 'storekeeper_issued_to_client');
                });
            },
            issue() {
                if (!this.deal || !this.deal.id || !this.deal.first_freight || !this.deal.first_freight.id) {
                    this.$store.commit('showSnackbar', ['Не установленны обязательные параметры параметры груза или заявки.', 6000, 'error']); 
                    return;
                }
                
                this.$refs.deliveryTo.doIssueCapture().then(r => {
                    this.$store.commit('showProgressBar', 'load-deal-card');
                    this.getIssueStatus().then(status => {
                        if (!status) {this.$store.commit('showSnackbar', ['Не найден статус выдачи груза.', 6000, 'error']); return;}
                        if (!this.deal.first_freight.currenttracking) {this.$store.commit('showSnackbar', ['У груза не установленно текущее местоположение. Проверьте трекинг.', 6000, 'error']); return;}

                        let data = {
                            freight_id:     this.deal.first_freight.id,
                            status_id:      status.id,
                            stock_id:       this.deal.first_freight.currenttracking.stock_id,
                            responsible_id: this.user.id,
                            date: this.moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                        };
                        this.$store.dispatch('stock/addFreightTracking', data).then(r => {
                            if (r) {
                                this.$store.commit('showSnackbar', ['Груз успешно выдан получателю', 6000, 'success']);
                                this.printDoc(this.deal.id, 'receipt');
                                this.onDealUpdate();
                            }
                        }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                    }, error => {
                        this.$store.commit('hideProgressBar', 'load-deal-card');
                        this.$store.commit('showSnackbar', ['Ошибка получения статуса выдачи груза.', 6000, 'error']);
                    });
                }, error => this.$store.commit('showSnackbar', ['Ошибка подписи.', 6000, 'error']));
            },
            formatPrice(price) {
                return parseFloat(price).toLocaleString('ru-RU', {style: 'currency', currency: 'RUB', minimumFractionDigits: 2}).replace(/,+/g, '.').replace(/\s+/g, ',').replace(',₽', '');
            },
            back() {
                if (!this.dirty) this.goBack();
                else this.$root.$emit(
                    'z-alert',
                    'Закрыть заявку?<br>Внесённые вами измненеия не сохранятся!',
                    'Изменённые поля выделенны синим цветом.',
                    () => this.goBack()
                );
            },
            goBack() {
                this.clear();
                let query = Object.assign({}, this.$route.query);
                if (query) delete query.clone_id;
                this.$router.push({ name: 'DealsNew', query: query});
            },
            changeCurrentTracking(data) {
                if (!data || !data.tracking) return;
                this.deal.first_freight.currenttracking = Object.assign({}, data.tracking);
            },
            updateDocuments(docs) {
                this.deal.documents = Object.assign([], docs);
            },
            changeActiveTab(value) {
                if (this.activeTab) {
                    let oldTab = this.tabs.find(item => item.name == this.activeTab);
                    if (oldTab.refs && oldTab.refs.length) this.validate(oldTab.refs).then(valid => {
                            valid = valid.findIndex(valid => !valid);
                            if (valid == -1) this.activeTab = value;
                        });
                    else this.activeTab = value;
                }
                this.activeTab = value;
            },
            dirtyClear() {
                Object.keys(this.isDirty).map(key => this.$set(this.isDirty, key, false));
            },
            HasTempReg(freight) {
                if (!freight || !freight.services || !Array.isArray(freight.services) || !freight.services.length) return false;
                return !!freight.services.find(item => parseInt(item.id) === 22);
            },
        },
        computed: {
            endpoint() {
                return this.$store.state.endpoint;
            },
            progressDealForm() {
                return this.progressObj['load-deal-card'];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            dealStatuses() {
                return this.$store.state.deals.statusesall;
            },
            currentDealStatus() {
                return this.dealStatuses.find(item => parseInt(item.id) === parseInt(this.deal.status_id));
            },
            currentDealStatusReason() {
                if (!this.currentDealStatus || !this.currentDealStatus.reasons || !this.currentDealStatus.reasons.length) return;
                return this.currentDealStatus.reasons.find(item => parseInt(item.id) === parseInt(this.deal.reason_id));
            },
            storage() {
                if (!this.storeDeal || !this.storeDeal.firstFreight || !this.storeDeal.firstFreight.storage) return [];
                return this.storeDeal.firstFreight.storage;
            },
            dirty() {
                if (!this.isDirty) return false;
                return !!Object.values(this.isDirty).find(item => item);
            },
            dirtyForOperations() {
                if (!this.isDirty) return false;
                return !!Object.keys(this.isDirty).find(key => key != 'operations' && this.isDirty[key]);
            },
            storeDeal() {
                return this.$store.state.deals.deal;
            },
            paymentMethods() {
                return this.$store.state.cost.payment_methods;
            },
            companies() {
                return this.$store.state.companies.companies;
            },
            currentCompany() {
                if (!this.deal.executor_company_id || !this.companies) return;
                return this.companies.find(company => parseInt(company.id) === parseInt(this.deal.executor_company_id));
            },
            withNDS() {
                if (!this.currentCompany) return false;

                return (parseInt(this.currentCompany.nds) === 1) ? true : false;
            },
            customersUL() {
                let customers = this.$store.state.customers.customers_ul;
                if (!customers || !customers.data || !customers.data.length) return [];
                customers = customers.data;
                customers.map(item => {
                    item.ul_inn_label  = item.inn  + ': ' + item.name + (item.kpp ? ' (' + item.kpp + ')' : '');
                    item.ul_name_label = item.name + ': ' + item.inn  + (item.kpp ? ' (' + item.kpp + ')' : '');
                });
                return customers;
            },
            customersFL() {
                let customers = this.$store.state.customers.customers_fl;
                if (!customers || !customers.data || !customers.data.length) return [];
                customers = customers.data;
                customers.map(item => {
                    item.fl_passport_label = item.passport_number + ': ' + item.name;
                    item.fl_name_label = item.name + ': ' + item.passport_number;
                });
                return customers;
            },
            payersUL() {
                return this.customersUL.filter(item => {
                    return !this.selectablePayersHidPass.find(hid => (hid == item.hid));
                });
            },
            payersFL() {
                return this.customersFL.filter(item => {
                    return !this.selectablePayersHidPass.find(passport_number => passport_number == item.passport_number);
                });
            },
            user() {
                return this.$store.state.users.current;
            },
            usersStocks() {
                return (this.user && this.user.stocks_id) ? this.user.stocks_id : [];
            },
            isUserAgent() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('agent')+1) : false;
            },
            isUserAdmin() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
            },
            isUserManager() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('managers')+1) : false;
            },/**
             * Если true, значит идёт "Принём груза", а не просто создание заявки
             * т.е. заявка создаётся в момент сдачи груза клиентом представителю на складе
             */
            isUserAgentForm() {
                return (this.$route.query && this.$route.query.agent) ? true : false;
            },
            printers() {
                if (!this.user || !this.user.printers) return [];
                return this.user.printers;
            },
            userStocks() {
                return (this.user && this.user.stocks_id) ? this.user.stocks_id : [];
            },
            ticketsPrintData() {
                return {
                    date:           (this.deal.first_freight && this.deal.first_freight.acceptedtracking && this.deal.first_freight.acceptedtracking.date) ? this.moment(this.deal.first_freight.acceptedtracking.date).format('DD.MM.YYYY') : '',
                    fromCity:       (this.deal.from_city     && this.deal.from_city.name) ? this.deal.from_city.name : ((this.deal.from_address && this.deal.from_address.value) ? this.deal.from_address.value.city : ''),
                    toCity:         (this.deal.to_city       && this.deal.to_city.name)   ? this.deal.to_city.name   : ((this.deal.to_address && this.deal.to_address.value)     ? this.deal.to_address.value.city   : ''),
                    trackingNumber: (this.deal && this.deal.first_freight) ? this.deal.first_freight.traking_number : null,
                    seatsNumber:    (this.storeDeal && this.storeDeal.first_freight) ? this.storeDeal.first_freight.seats_number   : null,
                    //seatsNumber:    (this.deal && this.deal.first_freight) ? this.deal.first_freight.seats_number   : null,
                    sender:         (this.deal && this.deal.sender    && this.deal.sender.name)    ? this.deal.sender.name    : '',
                    recipient:      (this.deal && this.deal.recipient && this.deal.recipient.name) ? this.deal.recipient.name : '',
                    tempReg:        (this.deal && this.deal.first_freight) ? this.HasTempReg(this.deal.first_freight) : false
                };
            },
            canIssue() {
                if (!this.deal || !this.deal.first_freight || parseInt(this.deal.status_issue_id) !== 1) return false;
                if (!this.deal.first_freight.issuedtracking || !this.deal.first_freight.issuedtracking.id) return true;
                return false;
            },
            paymentSum() {
                let result = 0;
                if (!this.deal.operations || !this.deal.operations.length) return result;
                this.deal.operations.map(item => {
                    if (parseInt(item.type) === 1) result += parseFloat(item.sum);
                });
                return result;
            },
            payerType() {
                return this.payerTypes.map(type => {
                    let r = false;
                    if (parseInt(this.deal.payer_type) === parseInt(type.value) && type.removable) r = true;
                    if (this.deal.payers && this.deal.payers.length && type.removable) {
                        let exist = this.deal.payers.find(payer => parseInt(payer.who) === parseInt(type.value));
                        if (exist) r = true;
                    }
                    type.disabled = r;
                    return type;
                });
            },
            aviablesPayerTypeLength() {
                return this.payerType.filter(item => !item.disabled).length;
            },
            selectablePayers() {
                let payers = [];
                if (this.deal.payer && (this.deal.payer.hid || this.deal.payer.passport_number))
                    payers.push({
                        id:   (this.deal.payer.id)   ? this.deal.payer.id   : null,
                        hid:  (this.deal.payer.hid)  ? this.deal.payer.hid  : null,
                        inn:  (this.deal.payer.inn)  ? this.deal.payer.inn  : null,
                        name: (this.deal.payer.name) ? this.deal.payer.name : null,
                        passport: (this.deal.payer.passport_number) ? this.deal.payer.passport_number : null,
                        nds:   (parseInt(this.deal.payer.nds) === 1) ? true : false,
                        debt:  (this.deal.payer.debt_sum) ? this.deal.payer.debt_sum : null,
                        issue: (parseInt(this.deal.payer.can_issue_freight) === 1) ? true : false,
                        who:  this.payerTypes.find(type => parseInt(type.value) === parseInt(this.deal.payer_type)),
                        payment_method_id: (this.deal.payment_method_id) ? this.deal.payment_method_id : null,
                    });

                
                if (this.deal.payers && this.deal.payers.length) this.deal.payers.map(payer => {
                    if (payer && payer.value && (payer.value.hid || payer.value.passport_number)) {
                        payers.push({
                            id:   (payer.value.id)   ? payer.value.id   : null,
                            hid:  (payer.value.hid)  ? payer.value.hid  : null,
                            inn:  (payer.value.inn)  ? payer.value.inn  : null,
                            name: (payer.value.name) ? payer.value.name : null,
                            passport: (payer.value.passport_number) ? payer.value.passport_number : null,
                            nds: (parseInt(payer.value.nds) === 1) ? true : false,
                            debt: (payer.value.debt_sum) ? payer.value.debt_sum : null,
                            issue: (parseInt(payer.value.can_issue_freight) === 1) ? true : false,
                            who:  this.payerTypes.find(type => parseInt(type.value) === parseInt(payer.who)),
                            payment_method_id: (payer.value && payer.value.pivot && payer.value.pivot.payment_method_id) ? payer.value.pivot.payment_method_id : null,
                        });
                    }
                });

                return payers.filter(payer => ((payer.hid || payer.passport) && payer.name && payer.who));
            },
            selectablePayersHidPass() {
                return this.selectablePayers.map(payer => payer.hid || payer.passport);
            },
            defaultPayer() {
                if (!this.selectablePayers || !this.selectablePayers.length) return;
                return this.selectablePayers.find(p => !!p);
            },
            

            isUserHasHighPermission() {
                return (this.isUserAdmin || this.isUserManager);
            },
            blockDeal() {
                return ((this.isIssusedToClient || this.isDealCanceled) && !this.isUserAdmin);
            },
            blockCustomers() {
                return false;
                
                if (!this.deal || !this.deal.documents || !this.deal.documents.length) return false;
                let blockDocs = ['bill', 'invoice_a4', 'act_a4'],
                    exist = this.deal.documents.find(item => !!(blockDocs.indexOf(item.type) + 1));

                return (exist) ? true : false;
            },
            canEditPrice() {
                // Админ всегда может изменять стоимость услуг и заявки
                if (this.isUserAdmin) return true;
                // Представитель не может редактировать никакие цены вообще
                if (this.isUserAgent) return false;

                // Остальные условия сработают только для менеджера

                // Если заявки выдана клиенту или отменена, то менеджер не может её редактировать
                if (this.isIssusedToClient || this.isDealCanceled) return false;

                // В остальных случая менеджер может редактировать цену
                return true;
            },

            isDealCanceled() {
                return (this.deal.status && this.deal.status.type === 'canceled')
            },
            isDealCompletePayment() {
                if (!this.deal || !this.paymentSum || !this.deal.first_freight || !this.deal.first_freight.price) return false;
                return (parseFloat(this.paymentSum) >= parseFloat(this.deal.first_freight.price));
            },
            isDealHasInvoice() {
                if (!this.deal || !this.deal.id || this.deal === 'new' || !this.deal.documents) return false;
                return this.deal.documents.find(doc => {
                    return (doc.type === 'invoice_a4' && doc.status == 'ACTUAL');
                });
            },
            isDealHasAct() {
                if (!this.deal || !this.deal.id || this.deal === 'new' || !this.deal.documents) return false;
                return this.deal.documents.find(doc => {
                    return (doc.type === 'act_a4' && doc.status == 'ACTUAL');
                });
            },
            isIssueToTransfer() {
                if (this.deal.first_freight && this.deal.first_freight.issuedtotransfertracking && this.deal.first_freight.issuedtotransfertracking.id) return true;
                return false;
            },
            isEnteredToStock() {
                if (this.deal.first_freight && this.deal.first_freight.enteredtostocktracking && this.deal.first_freight.enteredtostocktracking.id) return true;
                return false;
            },
            isIssusedToClient() {
                if (this.deal.first_freight && this.deal.first_freight.issuedtracking && this.deal.first_freight.issuedtracking.id) return true;
                return false;
            }
        },
        watch: {
            '$route.params.id'(id) {
                this.clear();
                this.init();
            },
            'deal.sender'(sender) {
                if (sender && sender.id) this.deal.sender_id = sender.id;
                else this.deal.sender_id = 'new';
                if (parseInt(this.deal.payer_type) === 1) this.deal.payer = Object.assign({}, this.deal.sender);
            },
            'deal.recipient'(recipient) {
                if (recipient && recipient.id) this.deal.recipient_id = recipient.id;
                else this.deal.recipient_id = 'new';
                if (parseInt(this.deal.payer_type) === 2) this.deal.payer = Object.assign({}, this.deal.recipient);
            },
            'deal.payer'(payer, old) {
                //Проверка нужна т.к. почему-то слушатель вызывается даже когда значения равны
                if (JSON.stringify(payer) === JSON.stringify(old)) return;
                if (payer && payer.id) this.deal.payer_id = payer.id;
                else this.deal.payer_id = 'new';

                this.resolvePayerNDS();
            },
            'companies'() {
                this.resolvePayerNDS();
            },
            'deal.delivery_method_from'() { // Следим за способом забора чтобы скинуть значения ПРР
                if (this.isDirty.from) this.getLuwParamFrom();
            },
            'deal.delivery_method_to'() { // Следим за способом отправления чтобы скинуть значения ПРР
                if (this.isDirty.to) this.getLuwParamTo();
            },
            // Сдедим за городом адреса забора чтобы получить актуальное значение ПРР, либо скинуть его
            'deal.from_address.value.city_fias_id'(n, o) {
                if (!this.isDirty.from || n == o) return;
                this.getLuwParamFrom();
            },
            // Сдедим за городом адреса отправления чтобы получить актуальное значение ПРР, либо скинуть его
            'deal.to_address.value.city_fias_id'(n, o) {
                if (!this.isDirty.to || n == o) return;
                this.getLuwParamTo();
            }
        }
    }
</script>
<style src="./Deal.sass" lang="sass"></style>


// WEBPACK FOOTER //
// Deal.vue?0219dba2